import OrganAnatomyVisual from "@/components/OrganAnatomyVisual";
import { Link } from "react-router-dom";
import { UserRound, ArrowUpRight } from "lucide-react";
import { OrganIcon } from "@/components/Shared";
import { FLOW_STEPS } from "@/components/CensimentoFigure";
import { StatusBadge, ResourceMessage } from "@/components/DadStatus";
import { healthState, coverage } from "@/lib/dadDesign";

export function HealthStatusCard({ resource, onRetry }) {
  const health = resource.data;
  const [state, label] = healthState(health);
  const percent = coverage(health?.coverage);
  return <section className="dad-panel" aria-labelledby="home-health-title">
    <span className="dad-eyebrow">Dashboard</span><h2 id="home-health-title">Stato di salute</h2>
    <ResourceMessage resource={resource} label="Salute" onRetry={onRetry} />
    {resource.status === "DATA" && <>
      <StatusBadge state={state}>{label}</StatusBadge>
      {health?.status !== "GREEN" && health?.message && <p>{health.message}</p>}
      <dl className="dad-health-meta"><div><dt>Copertura dati</dt><dd>{percent === null ? "UNKNOWN" : `${percent}%`}</dd></div>
        <div><dt>Ultima lettura</dt><dd>{health?.updated_at && Number.isFinite(Date.parse(health.updated_at)) ? new Date(health.updated_at).toLocaleString("it-CH") : "Non disponibile"}</dd></div></dl>
    </>}
    <p className="dad-caption">La copertura misura i dati disponibili. Non equivale alla salute del business. Valutazione aggregata in evoluzione.</p>
    <Link className="dad-text-link" to="/health-status">Apri il quadro generale <ArrowUpRight size={16} /></Link>
  </section>;
}
export function ConsciousnessCard() {
  return <aside className="dad-panel dad-consciousness">
    <UserRound size={24} aria-hidden="true" /><span className="dad-eyebrow">Coscienza</span><h2>Imprenditore</h2>
    <p>Decide e autorizza · Definisce obiettivi · Dà la direzione</p>
    <OrganAnatomyVisual organId="consciousness" compact/>
    <Link to="/actions" className="dad-text-link">Le tue decisioni <ArrowUpRight size={16} /></Link>
  </aside>;
}
export function InformationFlow() {
  return <section className="dad-flow" aria-labelledby="flow-title"><div className="dad-section-heading">
    <div><span className="dad-eyebrow">Dall’informazione alla decisione</span><h2 id="flow-title">Un sistema che collega.</h2></div>
    <p>Il modello di lavoro DAD. Le fasi non indicano elaborazioni in corso.</p></div>
    <ol>{FLOW_STEPS.map(step => <li key={step.id}><OrganIcon icon={step.icon} size={22} /><strong>{step.label}</strong><span>{step.sub}</span></li>)}</ol>
  </section>;
}
export function WorkSummary({ actions, documents, onRetry }) {
  const open = (actions.data || []).filter(a => a.status === "open");
  const review = (documents.data || []).filter(d => ["to_confirm", "anomaly", "failed"].includes(d.status));
  return <section className="dad-work" aria-label="Azioni e documenti">
    <div className="dad-panel"><span className="dad-eyebrow">La prossima decisione</span><h2>Azioni aperte</h2>
      <ResourceMessage resource={actions} label="Azioni" onRetry={onRetry} />
      {actions.status === "DATA" && (open.length ? <ul className="dad-action-list">{open.slice(0, 3).map(a =>
        <li key={a.action_id}><Link to="/actions"><strong>{a.title}</strong><span>{a.action_required}</span><ArrowUpRight size={18} /></Link></li>)}</ul> :
        <p>Nessuna azione aperta restituita dalla lettura.</p>)}
      <Link className="dad-text-link" to="/actions">Tutte le azioni <ArrowUpRight size={16} /></Link>
    </div>
    <div className="dad-panel"><span className="dad-eyebrow">Informazioni da completare</span><h2>Documenti da verificare</h2>
      <ResourceMessage resource={documents} label="Documenti" onRetry={onRetry} />
      {documents.status === "DATA" && <><p className="dad-count">{review.length}</p><p>Nei documenti restituiti dalla lettura. Il conteggio non certifica la completezza dell’archivio.</p></>}
      <Link className="dad-text-link" to="/queue">Apri la coda <ArrowUpRight size={16} /></Link>
    </div>
  </section>;
}
